import { render } from "./main-view-toolbar.vue?vue&type=template&id=01bb0545&scoped=true&ts=true"
import script from "./main-view-toolbar.vue?vue&type=script&lang=ts"
export * from "./main-view-toolbar.vue?vue&type=script&lang=ts"

import "./main-view-toolbar.vue?vue&type=style&index=0&id=01bb0545&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bb0545"]])

export default __exports__